/* Icon motion: the PDP feature icons and the "Explore the range" icons.

   An animated icon is an <svg class="fx fx-…" data-dur="…"> that carries its own
   <style>; at rest it is the plain icon, and .is-playing plays its move once. The
   icons are built by element-ops lib/python/icon_motion.

   - Range icons are inline already (snippets/_range-icon-motion.liquid).
   - Feature icons arrive as <img> files from Shopify Files, and a page cannot move
     the parts of an image. Once the row nears the viewport each file is fetched and
     placed inline in the <img>'s place. A file without class "fx" on its root (an
     icon with no motion yet) is left as the image it is.

   Only for a pointer that hovers and visitors who have not asked for reduced motion:
   on a phone nothing here runs and nothing is fetched. Loaded by more than one
   section, so it guards against running twice. */
(function () {
  if (window.__ebIconMotion) return;
  window.__ebIconMotion = true;

  var motion = window.matchMedia ? window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)') : null;
  if (!motion) return;

  var ITEMS = '.products-features__item, .explore-range__list-item';

  function play(svg) {
    if (!svg || svg.classList.contains('is-playing')) return;
    svg.classList.add('is-playing');
    /* Every move ends on a frame identical to the still, so taking the class off cannot jump. */
    window.setTimeout(function () {
      svg.classList.remove('is-playing');
    }, (Number(svg.getAttribute('data-dur')) || 1000) + 80);
  }

  document.addEventListener('mouseover', function (event) {
    if (!motion.matches || !event.target.closest) return;
    var item = event.target.closest(ITEMS);
    /* Only when the pointer comes in from outside the item, not as it moves within it. */
    if (!item || (event.relatedTarget && item.contains(event.relatedTarget))) return;
    play(item.querySelector('svg.fx'));
  });

  /* The files are our own (written by Ops), but nothing that could run is carried into the page. */
  function clean(svg) {
    var drop = svg.querySelectorAll('script, foreignObject, iframe, object, embed, image, a, title');
    for (var i = 0; i < drop.length; i++) drop[i].parentNode.removeChild(drop[i]);
    var all = svg.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      var attrs = all[j].attributes;
      for (var k = attrs.length - 1; k >= 0; k--) {
        var name = attrs[k].name.toLowerCase();
        var local = name.split(':').pop();
        if (name.indexOf('on') === 0 || (local === 'href' && attrs[k].value.charAt(0) !== '#')) all[j].removeAttribute(attrs[k].name);
      }
    }
  }

  function inline(img) {
    if (img.ebIconMotion) return;
    img.ebIconMotion = true;
    var url = img.currentSrc || img.src;
    if (!url || !/\.svg(?:[?#]|$)/i.test(url)) return;
    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('icon ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var svg = new DOMParser().parseFromString(text, 'image/svg+xml').documentElement;
        if (!svg || svg.nodeName !== 'svg' || !svg.classList.contains('fx') || !img.parentNode) return;
        clean(svg);
        svg.setAttribute('width', img.getAttribute('width') || '38');
        svg.setAttribute('height', img.getAttribute('height') || '38');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.removeAttribute('role');
        img.parentNode.replaceChild(document.importNode(svg, true), img);
      })
      .catch(function () {
        /* The image stays; the row just has no motion. */
      });
  }

  var observer = null;

  function arm() {
    if (!motion.matches || !window.fetch || !window.DOMParser) return;
    var images = document.querySelectorAll('.products-features-icon img');
    if (!images.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < images.length; i++) inline(images[i]);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            inline(entry.target);
          });
        },
        { rootMargin: '400px 0px' }
      );
    }
    for (var j = 0; j < images.length; j++) {
      if (!images[j].ebIconMotion) observer.observe(images[j]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
  /* A mouse can appear after load (a tablet with a trackpad), and the theme editor re-renders sections. */
  if (motion.addEventListener) motion.addEventListener('change', arm);
  document.addEventListener('shopify:section:load', arm);
})();
